import React from 'react';
import { Info } from 'lucide-react';
import LookAroundIcon from "../../packages/svgs/LookAroundIcon";

interface TempChatHeaderProps {
  isDarkMode: boolean;
}

export const TempChatHeader: React.FC<TempChatHeaderProps> = ({ isDarkMode }) => {
  return (
    <div className="w-[max-content] flex items-center justify-center group sms:gap-1 gap-2 px-3 py-2">
      <LookAroundIcon size={26} className={isDarkMode ? 'text-[#ffffff]' : 'text-[#2e2e2e]'} />
      
      {/* Mobile version - just "Incognito" text with hover tooltip */}
      <div className="relative xs:hidden">
        {/* Mobile Tooltip */}
        <div className={`absolute select-none -right-32 top-4 mt-2 px-3 py-2 text-xs rounded-md shadow-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50 max-w-xs ${
          isDarkMode 
            ? 'bg-[#1c1c1c] text-white border border-gray-700' 
            : 'bg-white text-gray-900 border border-gray-200'
        }`}>
          Incognito Chats won't appear in your history, and<br />
           will not be saved anywhere.
        </div>
      </div>

      {/* Desktop version - full text with info icon */}
      <div className="hidden xs:flex items-center gap-2">
        <span className={`text-md select-none font-medium ${
          isDarkMode ? 'text-[#ffffff90]' : 'text-[#2e2e2e]'
        }`}>
          Incognito
        </span>
        <div className="relative group">
          <Info className={`w-4 h-4 cursor-help ${
            isDarkMode ? 'text-[#ffffff90]' : 'text-[#2e2e2e]'
          }`} />
          {/* Desktop Tooltip */}
          <div className={`absolute select-none -left-20 -translate-x-1/2 top-full mt-2 px-3 py-2 text-xs rounded-md shadow-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50 max-w-xs border-0 ${
            isDarkMode 
              ? 'bg-[#1c1c1c] text-white' 
              : 'bg-white text-gray-900'
          }`}>
            Incognito Chats won't appear in your history, and<br />
             will not be saved anywhere.
          </div>
        </div>
      </div>
    </div>
  );
};
